const steps = [
  { key: "search", label: "Suche" },
  { key: "booking", label: "Buchung" },
  { key: "checkout", label: "Zur Kasse" },
  { key: "confirmation", label: "Best\xE4tigung" }
];
const ProgressBar = ({ currentStep }) => {
  const currentIndex = Math.max(steps.findIndex((step) => step.key === currentStep), 0);
  const progressPercent = steps.length > 1 ? currentIndex / (steps.length - 1) * 100 : 0;
  return <div className="border-b border-emerald-200 bg-white/95">
            <div className="mx-auto max-w-7xl px-3 py-4 sm:px-4 sm:py-5 md:px-6">
                <div className="relative">
                    <div className="pointer-events-none absolute left-[12.5%] right-[12.5%] top-3 h-[2px] rounded-full bg-emerald-100 sm:top-4" />
                    <div
    className="pointer-events-none absolute left-[12.5%] top-3 h-[2px] rounded-full bg-[#1f4d3c] transition-all duration-300 sm:top-4"
    style={{ width: `${progressPercent * 0.75}%` }}
  />

                    <div className="relative z-10 grid grid-cols-4 gap-1 sm:gap-2 md:gap-3">
                        {steps.map((step, index) => {
    const isCompleted = index < currentIndex;
    const isActive = index === currentIndex;
    return <div key={step.key} className="flex min-w-0 flex-col items-center text-center">
                                    <span
      className={`flex h-6 w-6 items-center justify-center rounded-full text-[11px] font-semibold sm:h-8 sm:w-8 sm:text-xs ${isCompleted ? "bg-[#1f4d3c] text-white" : isActive ? "bg-[#1f4d3c] text-white ring-2 ring-emerald-200" : "bg-emerald-50 text-[#1f4d3c]"}`}
    >
                                        {index + 1}
                                    </span>
                                    <span
      className={`mt-2 max-w-[86px] text-[10px] font-semibold leading-tight tracking-[0.06em] sm:max-w-none sm:text-xs md:text-sm ${isCompleted || isActive ? "text-[#1f4d3c]" : "text-gray-500"}`}
    >
                                        {step.label}
                                    </span>
                                </div>;
  })}
                    </div>
                </div>
            </div>
        </div>;
};
export default ProgressBar;
